// ==============================|| OVERRIDES - SELECT (with OutlinedInput) ||============================== //

export default function Select() {
  return {
    MuiSelect: {
      styleOverrides: {
        select: {
          display: 'flex',
          alignItems: 'center',
          boxSizing: 'border-box'
        }
      }
    }
  };
}
